module.exports={
	"Form": "ArtifactTypeViewManifest",
	"Scope": "ArtifactType-View",
	"Descriptors":
	{
		"ArtifactTypeDetails.IDArtifactType":
		{
			"Name": "ID",
			"Hash": "ArtifactTypeView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ArtifactTypeIdentity",
				"Group": "ArtifactTypeIdentity"
			}
		},
		"ArtifactTypeDetails.GUIDArtifactType":
		{
			"Name": "GUID",
			"Hash": "ArtifactTypeView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ArtifactTypeIdentity",
				"Group": "ArtifactTypeIdentity"
			}
		},
		"ArtifactTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "ArtifactTypeView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ArtifactTypeIdentity",
				"Group": "ArtifactTypeIdentity"
			}
		},
		"ArtifactTypeDetails.Schemata":
		{
			"Name": "Schema Definition (JSON)",
			"Hash": "ArtifactTypeView-Schemata",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "ArtifactTypeSchema",
				"Group": "ArtifactTypeSchema"
			}
		},
		"ArtifactTypeDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "ArtifactTypeView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ArtifactTypeAudit",
				"Group": "ArtifactTypeAudit"
			}
		},
		"ArtifactTypeDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "ArtifactTypeView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ArtifactTypeAudit",
				"Group": "ArtifactTypeAudit"
			}
		},
		"ArtifactTypeDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "ArtifactTypeView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ArtifactTypeAudit",
				"Group": "ArtifactTypeAudit"
			}
		},
		"ArtifactTypeDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "ArtifactTypeView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ArtifactTypeAudit",
				"Group": "ArtifactTypeAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ArtifactTypeIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ArtifactTypeIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Schema",
			"Hash": "ArtifactTypeSchema",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Schema",
					"Hash": "ArtifactTypeSchema",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "ArtifactTypeAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "ArtifactTypeAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
